<template>
   <div v-show="fileSheets.length > 0">
      <label for="Range_input">
          Nom de la feuille cible
      </label>
      <b-form-select
          id="Range_input"
          v-model="range"
          :options="fileSheets"
          class="mb-2">
      </b-form-select>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import google_service from "../../services/google.js";

const props = defineProps({
    credentialName: {
        type: String,
        required: true
    },
    spreadsheetId: {
        type: String,
        required: true
    }
});

const emits = defineEmits(["updateRange"]);

const fileSheets = ref([]);
const range = ref("");

const errorMessage = ref("");

const loadSheets = async () => {
    // loadspinner
    errorMessage.value = "";

    let spreadsheetId = props.spreadsheetId;

    let sheets = await google_service.getSheets(spreadsheetId, props.credentialName) 
                        .catch((err) => {
                            console.log("Error getting sheets: ", err);
                        });

    console.log("Got sheets: ", sheets);
    if (!sheets) {
        errorMessage.value = "Erreur lors de la récupération des feuilles.";
        return;
    }
    sheets = sheets.sheets;

    fileSheets.value = sheets.map((sheet) => {
        return {
            value: sheet.title,
            text: sheet.title
        }
    });

    range.value = fileSheets.value[0].value;
}

watch(() => props.spreadsheetId, async (newVal, oldVal) => {
  console.log("Loading sheets for spreadsheet: ", newVal);
  await loadSheets();
});

console.log("Loading initial sheets");
loadSheets();

watch(range, async (newVal, oldVal) => {
    console.log("Range changed: ", newVal);
    emits('updateRange', newVal);
});

</script>